import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LdButton, LdIcon, LdTypo } from "@emdgroup-liquid/liquid/dist/react";
import { LightBox } from "@liquid-design/liquid-design-react";

import Card from "components/Card";
import { CloneIcon } from "components/Icons";
import { Survey } from "typings/api/types";
import moment from "moment";

interface Props {
  survey: Survey;
  onDeleteSurvey?: (surveyId: string) => void;
}
const SurveyOverview: FC<Props> = ({ survey, onDeleteSurvey }) => {
  const navigate = useNavigate();
  const { surveyName, surveyId } = survey;
  const [modal, setModal] = useState<string | null>(null);
  const shareUrl = () =>
    `${window.location.protocol}//${window.location.host}/answer?survey=${surveyId}`;

  const handleEndSurvey = () => {
    setModal(null);
    if (onDeleteSurvey !== undefined) {
      onDeleteSurvey(surveyId);
    }
  };

  const actionsArea = () => (
    <>
      {onDeleteSurvey !== undefined && (
        <LdButton onClick={() => setModal("deleteSurvey")} mode="danger">
          <LdIcon name="bin" />
          Delete Survey
        </LdButton>
      )}

      <LdButton
        onClick={() => navigator.clipboard.writeText(shareUrl())}
        mode="secondary"
      >
        <LdIcon>
          <CloneIcon />
        </LdIcon>
        <span>Share URL</span>
      </LdButton>
    </>
  );
  return (
    <>
      <Card
        className="w-full items-start"
        onClick={() => navigate(`/surveys/${surveyId}`)}
        actionsArea={actionsArea()}
      >
        <LdTypo variant="h2" className="text-left">
          {surveyName}
        </LdTypo>
        <LdTypo>
          {survey.participants?.length}{" "}
          {survey.participants?.length === 1 ? "Person" : "People"} invited
        </LdTypo>
        {survey.frequency === "once" ? (
          <LdTypo>
            Ends in {moment(survey.endDate).fromNow()}, on{" "}
            {moment(survey.endDate).format("ddd., DD.MM.YYYY,  mm:HH")}
          </LdTypo>
        ) : (
          <LdTypo>
            <span className="capitalize">{survey.frequency}</span> recurring
            until {moment(survey.endDate).format("ddd., DD.MM.YYYY")}
          </LdTypo>
        )}
      </Card>
      <LightBox
        className="ld-theme-bubblegum"
        open={modal === "deleteSurvey"}
        onClose={() => setModal(null)}
      >
        <LdTypo variant="h2">Delete Survey?</LdTypo>
        <LdTypo>
          Do you really want to delete this Survey? This action can't be undone.
        </LdTypo>
        <div className="flex flex-row mt-ld-32 gap-4 justify-end">
          <LdButton
            className="flex-grow md:grow-0"
            mode="secondary"
            onClick={() => setModal(null)}
          >
            No, I'm good
          </LdButton>
          {onDeleteSurvey !== undefined && (
            <LdButton mode="danger" onClick={handleEndSurvey}>
              Yes, Delete Survey
            </LdButton>
          )}
        </div>
      </LightBox>
    </>
  );
};

export default SurveyOverview;
